import type { Theme } from '@mui/material/styles';

import { HF_BODY_STYLES } from './layoutConstants';

const IOS_INPUT_SELECTORS = [
    "input[type='color']",
    "input[type='date']",
    "input[type='datetime']",
    "input[type='datetime-local']",
    "input[type='email']",
    "input[type='month']",
    "input[type='number']",
    "input[type='password']",
    "input[type='search']",
    "input[type='tel']",
    "input[type='text']",
    "input[type='time']",
    "input[type='url']",
    "input[type='week']",
    'select:focus',
    'textarea'
].join(', ');

/** Global document styles (formerly `global.scss`). Applied via `MuiCssBaseline`. */
export const hfCssBaselineStyleOverrides = (theme: Theme) => ({
    html: {
        height: '100%'
    },
    body: {
        height: '100%',
        overflowX: 'hidden',
        backgroundColor: theme.palette.hfLayout.surface,
        fontFamily: HF_BODY_STYLES.fontFamily,
        fontSize: `${HF_BODY_STYLES.fontSizePx}px`,
        color: HF_BODY_STYLES.textColor
    },
    '#root': {
        height: '100%'
    },
    label: {
        fontWeight: 700
    },
    'a:not(.MuiButton-root):not(.MuiIconButton-root)': {
        color: theme.palette.primary.main,
        textDecoration: 'none',
        cursor: 'pointer',
        '&:hover': {
            color: theme.palette.primary.dark,
            textDecoration: 'underline',
            cursor: 'pointer'
        }
    },
    '.highcharts-credits': {
        display: 'none'
    },
    '@media screen and (-webkit-min-device-pixel-ratio: 0)': {
        [IOS_INPUT_SELECTORS]: {
            fontSize: `${HF_BODY_STYLES.iosInputFontSizePx}px`
        }
    }
});
